import React, { useRef, useState, useEffect } from 'react';
import { Button, SparkIcon, PopoverMenu } from '@spark';

// Panel alignment relative to the dots trigger: 'end' (default) right-aligns
// the panel — for triggers at the right edge (card corner / table row);
// 'start' left-aligns it — for triggers near the left edge (project header).
const basePanelStyle = {
    position: 'absolute',
    top: 'calc(100% + 4px)',
    zIndex: 1400,
};

/**
 * Project Edit/Delete overflow menu (Spark).
 * Lightweight open/close + click-outside, PopoverMenu panel, dots trigger button.
 */
export const ProjectOverflowMenu = ({ onEdit, onDelete, align = 'end', deleteLabel = 'Delete Project' }) => {
    const [open, setOpen] = useState(false);
    const wrapRef = useRef(null);

    useEffect(() => {
        if (!open) return undefined;
        const handleOutside = (e) => {
            if (wrapRef.current && !wrapRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleOutside);
        return () => document.removeEventListener('mousedown', handleOutside);
    }, [open]);

    const items = [
        {
            label: 'Edit project details',
            showPrefixIcon: true,
            prefixIconSlug: 'edit',
            disableWhenReadOnly: true,
            onClick: () => { setOpen(false); onEdit?.(); },
        },
        {
            label: deleteLabel,
            showPrefixIcon: true,
            prefixIconSlug: 'trash',
            disableWhenReadOnly: true,
            onClick: () => { setOpen(false); onDelete?.(); },
        },
    ];

    return (
        <div ref={wrapRef} style={{ position: 'relative', display: 'inline-flex' }}>
            <Button
                variant="ghost"
                size="small"
                aria-label="Project actions"
                icon={<SparkIcon slug="dots" size="small" />}
                onClick={(e) => { e.stopPropagation(); setOpen((o) => !o); }}
            />
            {open && (
                <div
                    style={{ ...basePanelStyle, ...(align === 'start' ? { left: 0 } : { right: 0 }) }}
                    onClick={(e) => e.stopPropagation()}
                >
                    <PopoverMenu tip={false} items={items} />
                </div>
            )}
        </div>
    );
};

export default ProjectOverflowMenu;
